import v1requests from './v1requests'

export default [v1requests]
